import { createRoute, useNavigate, Link } from '@tanstack/react-router';
import { useEffect, useState } from 'react';
import { z } from 'zod';
import { Route as rootRoute } from './__root';
import { useAuthStore } from '../store/auth.store';
import { AuthShell } from '../components/AuthShell';
import type { OperatorRole } from '@netsuite-ai/types';

const searchSchema = z.object({ token: z.string().catch('') });

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/verify',
  validateSearch: searchSchema,
  component: VerifyPage,
});

function VerifyPage() {
  const { token } = Route.useSearch();
  const navigate = useNavigate();
  const setSession = useAuthStore((s) => s.setSession);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!token) {
      setError('Missing login token.');
      return;
    }
    fetch(`/api/console/auth/verify?token=${token}`)
      .then(async (res) => {
        const data = await res.json();
        if (!res.ok) {
          setError(data.error ?? 'Invalid or expired link.');
          return;
        }
        const payload = JSON.parse(atob(data.accessToken.split('.')[1]));
        setSession(data.accessToken, payload.role as OperatorRole);
        navigate({ to: '/' });
      })
      .catch(() => setError('Something went wrong.'));
  }, [token]);

  return (
    <AuthShell>
      {error ? (
        <>
          <p className="text-danger text-center text-sm">{error}</p>
          <div className="mt-6 flex justify-center">
            <Link
              to="/login"
              className="text-muted hover:text-primary text-xs underline transition-colors"
            >
              Back to log in
            </Link>
          </div>
        </>
      ) : (
        <p className="text-muted text-center text-sm">Signing you in…</p>
      )}
    </AuthShell>
  );
}
